// Slider Navigation
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.purple-slider');

  sliders.forEach((slider) => {
    const sliderContainer = slider.querySelector('.slider-container');
    const slides = sliderContainer ? sliderContainer.querySelectorAll('.slide') : [];
    const navigation = slider.querySelector('.slider-navigation');

    if (!sliderContainer || slides.length === 0 || !navigation) return;

    // Select existing prev and next buttons
    const prevButton = navigation.querySelector('.slider-prev');
    const nextButton = navigation.querySelector('.slider-next');

    if (!prevButton || !nextButton) return;

    let currentSlide = 0;
    let isScrolling = false;

    // Function to scroll to a specific slide
    const scrollToSlide = (index) => {
      if (index < 0 || index >= slides.length) return;

      isScrolling = true;
      currentSlide = index;

      // Calculate scroll position based on the target slide
      const targetSlide = slides[index];
      const containerRect = sliderContainer.getBoundingClientRect();
      const slideRect = targetSlide.getBoundingClientRect();
      const scrollLeft = sliderContainer.scrollLeft + (slideRect.left - containerRect.left);

      sliderContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });

      updateButtonStates();

      // Reset isScrolling flag after animation completes
      setTimeout(() => {
        isScrolling = false;
      }, 500);
    };

    // Update button states based on current position
    const updateButtonStates = () => {
      prevButton.disabled = currentSlide === 0;
      nextButton.disabled = currentSlide === slides.length - 1;

      prevButton.style.opacity = currentSlide === 0 ? '0.3' : '';
      nextButton.style.opacity = currentSlide === slides.length - 1 ? '0.3' : '';
    };

    // Previous button click
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Prev clicked, currentSlide:', currentSlide);
      if (currentSlide > 0) {
        scrollToSlide(currentSlide - 1);
      }
    });

    // Next button click
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Next clicked, currentSlide:', currentSlide);
      if (currentSlide < slides.length - 1) {
        scrollToSlide(currentSlide + 1);
      }
    });

    // Update current slide on scroll (only when not programmatically scrolling)
    let scrollTimeout;
    sliderContainer.addEventListener('scroll', () => {
      if (isScrolling) return;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        // Find which slide is most in view
        let newSlide = 0;
        let maxVisibility = 0;

        slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const containerRect = sliderContainer.getBoundingClientRect();

          // Calculate how much of the slide is visible
          const visibleWidth = Math.min(slideRect.right, containerRect.right) - Math.max(slideRect.left, containerRect.left);

          if (visibleWidth > maxVisibility) {
            maxVisibility = visibleWidth;
            newSlide = index;
          }
        });

        console.log('Scroll detected - newSlide:', newSlide, 'currentSlide:', currentSlide);

        if (newSlide !== currentSlide && newSlide >= 0 && newSlide < slides.length) {
          currentSlide = newSlide;
          updateButtonStates();
        }
      }, 150);
    });

    // Initial state
    updateButtonStates();
  });
});
